import { InjectionToken } from '@angular/core';

export const LOCAL_STORAGE = new InjectionToken<Storage>('LOCAL_STORAGE', {
  providedIn: 'root',
  factory: () => (typeof window !== 'undefined' ? window.localStorage : (null as unknown as Storage)),
});

export const SESSION_STORAGE = new InjectionToken<Storage>('SESSION_STORAGE', {
  providedIn: 'root',
  factory: () => (typeof window !== 'undefined' ? window.sessionStorage : (null as unknown as Storage)),
});

export const WINDOW = new InjectionToken<Window>('WINDOW', {
  providedIn: 'root',
  factory: () => (typeof window !== 'undefined' ? window : (null as unknown as Window)),
});
